/**
 * This custom label is a workaround by directly rotating the text that is used to act as a label to the y axis
 * TODO: Eventually replace this with ReCharts angle property when bug fix is implemented
 * @param height
 * @param value
 */
export default function RotatedYAxisLabelRight({
  height,
  width,
  value,
}: {
  height: number;
  width: number;
  value: number;
}) {
  return (
    <g>
      <text
        transform={`rotate(90,15,0) translate(${(height * 0.8) / 2},-${width})`}
      >
        {value}
      </text>
    </g>
  );
}
